const initialState = {
  bookings: [],
  bookingData: null,
};

export default (state = initialState, action) => {
  const { type, data } = action;

  switch(type) {
  case 'BOOKINGS_LIST:LIST:SET':
    return {
      ...state,
      bookings: data,
    };
  case 'BOOKINGS_LIST:BOOKING_DATA:SET':
    return {
      ...state,
      bookingData: data,
    };
  default:
    return state;
  }
};
